
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/onlyfans-caption-generator",
      function () {
        return require("private-next-pages/onlyfans-caption-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/onlyfans-caption-generator"])
      });
    }
  